import { DEFAULT_ADDRESS } from '~/config'

import type { Address } from '~/types'

const sameAddressFields = () => {
  return ['street1', 'city', 'stateProvince', 'country', 'zipPostal']
}

export const sameAddress = (a = {}, b = {}) => {
  return sameAddressFields().every((k) => a[k] === b[k])
}

export const addressDefaults = (
  addresses: Address[],
): {
  billingAddress: Address
  shippingAddress: Address
  sameAddress: boolean
} => {
  const billingAddress = addresses.find((a) => a.type === 'billing')
  const shippingAddress = addresses.find((a) => a.type === 'shipping')
  return {
    billingAddress: { ...DEFAULT_ADDRESS, ...billingAddress, type: 'billing' },
    shippingAddress: {
      ...DEFAULT_ADDRESS,
      ...shippingAddress,
      type: 'shipping',
    },
    sameAddress: sameAddress(billingAddress, shippingAddress),
  }
}
